"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_ES_TRANS = {
    'time picker': 'Selector de Tiempo',
    'today': 'Hoy',
    'set time': 'Seleccionar Tiempo',
    'close': 'Cerrar',
    'cancel': 'Cancelar',
    'confirm': 'Confirmar',
    'hour': 'Hora',
    'minute': 'Minuto',
    'second': 'Segundo',
};
//# sourceMappingURL=es.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/es.js
// module id = ../../../../ng-pick-datetime/locale/es.js
// module chunks = 15